<template>
  <div class="whereby-wrap">
    <div id="whereby-meeting">
      <iframe
        v-if="startMeeting"
        id="whereby-embed"
        :src="meetingUrl"
        allow="camera; microphone; fullscreen; speaker; display-capture;"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      startMeeting: false,
    };
  },
  methods: {},
  computed: {
    meetingReady: function () {
      return this.roomUrl !== null && this.userName !== "";
    },
    meetingUrl: function () {
      if (this.$store.state.user.isAdmin) {
        return (
          this.$store.state.session.hostRoomUrl +
          "&embed&displayName=OPERATOR&leaveButton=off&recording=on&pipButton=off&background=off&people=off"
        );
      } else {
        return (
          this.roomUrl +
          "?embed&background=off&pipButton=off&displayName=" +
          this.userName
        );
      }
    },
    ...mapState({
      roomUrl: (state) => state.session.roomUrl,
      userName: (state) => state.user.name,
    }),
  },
  watch: {
    roomUrl(newValue, oldValue) {
      if (this.meetingReady) {
        this.startMeeting = true;
      }
    },
    userName(newValue, oldValue) {
      if (this.meetingReady) {
        this.startMeeting = true;
      }
    },
  },
};
</script>

<style lang="less">
.whereby-wrap {
  flex: 1;
  position: relative;
}

#whereby-meeting {
  width: 100%;
  max-width: 256px;
  max-width: 256px;
  height: 100%;
  padding-left: 30px;
  padding-right: 30px;
  position: absolute;
  right: 0;
}

#whereby-embed {
  width: 100%;
  height: 100%;
  border: 0;

  .Scrollbar-366Y {
    display: none !important;
  }
}
</style>